export default {"src":"/_next/static/media/essay-mini.6ceaa2d3.svg","height":24,"width":24};